module.exports = __webpack_public_path__ + "static/media/iss-logo.dea67e10.png";